import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';

export type TranscriptMessage = {
  role: 'user' | 'agent';
  time_in_call_secs?: number;
  message: string;
  timestamp?: number;
};

export type ConversationMetadata = {
  start_time_unix_secs: number;
  call_duration_secs: number;
};

export type ConversationDetailResponse = {
  agent_id: string;
  conversation_id: string;
  status: 'processing' | 'completed' | 'failed';
  transcript: TranscriptMessage[];
  metadata: ConversationMetadata;
  has_audio: boolean;
  has_user_audio: boolean;
  has_response_audio: boolean;
};

export type ConversationDetailsDTO = {
  conversationId: string;
};

export const getConversationDetails = ({
  conversationId,
}: ConversationDetailsDTO): Promise<ConversationDetailResponse> => {
  return axios.get(`/chatbot/conversations/${conversationId}`);
};

type UseConversationDetailsOptions = {
  config?: MutationConfig<typeof getConversationDetails>;
};

export const useGetConversationDetails = ({ config }: UseConversationDetailsOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getConversationDetails,
  });
};
